export default "__VITE_ASSET__DIdk6J1f__"